"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnlineQueueStatus = void 0;
/**
 * Enum representing possible queue statuses.
 */
var OnlineQueueStatus;
(function (OnlineQueueStatus) {
    OnlineQueueStatus[OnlineQueueStatus["WAITING"] = 1] = "WAITING";
    OnlineQueueStatus[OnlineQueueStatus["ACTIVE"] = 2] = "ACTIVE";
    OnlineQueueStatus[OnlineQueueStatus["EMPTY"] = 3] = "EMPTY";
    OnlineQueueStatus[OnlineQueueStatus["EXPIRED"] = 4] = "EXPIRED";
})(OnlineQueueStatus || (exports.OnlineQueueStatus = OnlineQueueStatus = {}));
